import React from 'react';
import { CLIENTS } from '../../data/credibility.mjs';
import './credibility.css';

/**
 * Carrusel infinito de logos de clientes (CSS puro: @keyframes + translateX).
 * - Sólo muestra clientes con `permission: true` (autorización escrita).
 * - Autoplay, pausa en hover/focus, respeta prefers-reduced-motion.
 * - Renderiza null si no hay logos autorizados.
 */
const ClientLogos = ({ clients = CLIENTS, title = 'Empresas que confían en nosotros' }) => {
    const authorized = clients.filter((c) => c.permission);
    if (authorized.length === 0) return null;

    // Con pocos logos el carril quedaría más corto que la pantalla y el bucle dejaría huecos:
    // repetimos el set hasta tener al menos MIN_ITEMS por mitad.
    const MIN_ITEMS = 10;
    const reps = Math.max(1, Math.ceil(MIN_ITEMS / authorized.length));
    const visible = Array.from({ length: reps }, () => authorized).flat();

    // Duración proporcional al número de logos para velocidad constante.
    const duration = `${Math.max(20, visible.length * 4)}s`;

    const renderItem = (c, i, clone) => {
        const img = <img src={c.logo} alt={c.name} title={c.sector ? `${c.name} — ${c.sector}` : c.name} loading="lazy" />;
        return (
            <div className={`client-logos__item${clone ? ' client-logos__item--clone' : ''}`} key={`${c.name}-${clone ? 'b' : 'a'}-${i}`} aria-hidden={clone ? 'true' : undefined}>
                {c.url ? (
                    <a href={c.url} target="_blank" rel="noopener noreferrer" tabIndex={clone ? -1 : 0} aria-label={c.name}>
                        {img}
                    </a>
                ) : (
                    img
                )}
            </div>
        );
    };

    return (
        <section className="client-logos" aria-label="Clientes de Coralan Multiservice">
            <div className="container" data-reveal="fade">
                <p className="client-logos__title">{title}</p>
            </div>
            <div className="client-logos__viewport">
                <div className="client-logos__track" style={{ '--client-logos-duration': duration }}>
                    {visible.map((c, i) => renderItem(c, i, i >= authorized.length))}
                    {/* Copia para el bucle infinito */}
                    {visible.map((c, i) => renderItem(c, i + visible.length, true))}
                </div>
            </div>
        </section>
    );
};

export default ClientLogos;
